// extracted by mini-css-extract-plugin
export var textarea = "t_4";